import type { ToolCallSegment } from './types';

export type ToolStateClass = 'running' | 'done' | 'error';

export function toolKind(tool: ToolCallSegment | null | undefined): string {
  const metaKind = typeof tool?.meta?.kind === 'string' ? tool.meta.kind : '';
  return tool?.kind || metaKind || '';
}

export function toolTitle(tool: ToolCallSegment | null | undefined): string {
  const metaTitle = typeof tool?.meta?.title === 'string' ? tool.meta.title : '';
  if (metaTitle) return metaTitle;
  return tool?.name || 'Tool';
}

export function toolSubtitle(tool: ToolCallSegment | null | undefined): string {
  const metaSubtitle = typeof tool?.meta?.subtitle === 'string' ? tool.meta.subtitle : '';
  if (metaSubtitle) return metaSubtitle;
  if (toolKind(tool) === 'command_execution') {
    const input = tool?.input as { command?: unknown } | null | undefined;
    return typeof input?.command === 'string' ? input.command : '';
  }
  return '';
}

export function stringifyToolValue(value: unknown): string {
  if (typeof value === 'string') return value;
  if (value === null || value === undefined) return '';
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}

export function toolStateLabel(tool: ToolCallSegment | null | undefined, done: boolean): string {
  if (!done) return 'Running';
  if (toolKind(tool) === 'runtime_error') return 'Error';
  if (toolKind(tool) === 'command_execution' && typeof tool?.meta?.exitCode === 'number') {
    return `Exit ${tool.meta.exitCode}`;
  }
  return 'Done';
}

export function toolStateClass(tool: ToolCallSegment | null | undefined, done: boolean): ToolStateClass {
  if (!done) return 'running';
  if (toolKind(tool) === 'runtime_error') return 'error';
  if (toolKind(tool) === 'command_execution' && typeof tool?.meta?.exitCode === 'number' && tool.meta.exitCode !== 0) {
    return 'error';
  }
  return 'done';
}

export function toolGroupSummaryText(toolItems: ToolCallSegment[]): string {
  const items = Array.isArray(toolItems) ? toolItems : [];
  const total = items.length;
  const running = items.filter((item) => item?.done === false).length;
  const failed = items.filter((item) => (
    toolStateClass(item, item?.done !== false) === 'error'
  )).length;
  const stats = [];
  if (running > 0) stats.push(`${running} 个运行中`);
  if (failed > 0) stats.push(`${failed} 个异常`);
  return [`${total} 个工具调用`, ...stats].join(' · ');
}
